/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CoreBaseService } from '../core-base-service';
import { CoreApiConfiguration } from '../core-api-configuration';
import { CoreStrictHttpResponse } from '../core-strict-http-response';

import { CoreProjectSubtaskCommentResponseDto } from '../models/core-project-subtask-comment-response-dto';
import { projectSubtaskCommentsControllerCreate } from '../fn/project-subtask-comments/project-subtask-comments-controller-create';
import { ProjectSubtaskCommentsControllerCreate$Params } from '../fn/project-subtask-comments/project-subtask-comments-controller-create';
import { projectSubtaskCommentsControllerDelete } from '../fn/project-subtask-comments/project-subtask-comments-controller-delete';
import { ProjectSubtaskCommentsControllerDelete$Params } from '../fn/project-subtask-comments/project-subtask-comments-controller-delete';
import { projectSubtaskCommentsControllerFindBySubtask } from '../fn/project-subtask-comments/project-subtask-comments-controller-find-by-subtask';
import { ProjectSubtaskCommentsControllerFindBySubtask$Params } from '../fn/project-subtask-comments/project-subtask-comments-controller-find-by-subtask';
import { projectSubtaskCommentsControllerFindOne } from '../fn/project-subtask-comments/project-subtask-comments-controller-find-one';
import { ProjectSubtaskCommentsControllerFindOne$Params } from '../fn/project-subtask-comments/project-subtask-comments-controller-find-one';
import { projectSubtaskCommentsControllerUpdate } from '../fn/project-subtask-comments/project-subtask-comments-controller-update';
import { ProjectSubtaskCommentsControllerUpdate$Params } from '../fn/project-subtask-comments/project-subtask-comments-controller-update';

@Injectable({ providedIn: 'root' })
export class CoreProjectSubtaskCommentsService extends CoreBaseService {
  constructor(config: CoreApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `projectSubtaskCommentsControllerFindBySubtask()` */
  static readonly ProjectSubtaskCommentsControllerFindBySubtaskPath = '/o2-core/project-subtask-comments/{tenant}';

  /**
   * Retrieve all comments for a specific subtask.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSubtaskCommentsControllerFindBySubtask()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSubtaskCommentsControllerFindBySubtask$Response(params: ProjectSubtaskCommentsControllerFindBySubtask$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreProjectSubtaskCommentResponseDto>>> {
    const obs = projectSubtaskCommentsControllerFindBySubtask(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve all comments for a specific subtask.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSubtaskCommentsControllerFindBySubtask$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSubtaskCommentsControllerFindBySubtask(params: ProjectSubtaskCommentsControllerFindBySubtask$Params, context?: HttpContext): Observable<Array<CoreProjectSubtaskCommentResponseDto>> {
    const resp = this.projectSubtaskCommentsControllerFindBySubtask$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<Array<CoreProjectSubtaskCommentResponseDto>>): Array<CoreProjectSubtaskCommentResponseDto> => r.body)
    );
  }

  /** Path part for operation `projectSubtaskCommentsControllerCreate()` */
  static readonly ProjectSubtaskCommentsControllerCreatePath = '/o2-core/project-subtask-comments/{tenant}';

  /**
   * Create a new comment for a subtask.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSubtaskCommentsControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectSubtaskCommentsControllerCreate$Response(params: ProjectSubtaskCommentsControllerCreate$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectSubtaskCommentResponseDto>> {
    const obs = projectSubtaskCommentsControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a new comment for a subtask.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSubtaskCommentsControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectSubtaskCommentsControllerCreate(params: ProjectSubtaskCommentsControllerCreate$Params, context?: HttpContext): Observable<CoreProjectSubtaskCommentResponseDto> {
    const resp = this.projectSubtaskCommentsControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreProjectSubtaskCommentResponseDto>): CoreProjectSubtaskCommentResponseDto => r.body)
    );
  }

  /** Path part for operation `projectSubtaskCommentsControllerFindOne()` */
  static readonly ProjectSubtaskCommentsControllerFindOnePath = '/o2-core/project-subtask-comments/{tenant}/{id}';

  /**
   * Retrieve a comment by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSubtaskCommentsControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSubtaskCommentsControllerFindOne$Response(params: ProjectSubtaskCommentsControllerFindOne$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectSubtaskCommentResponseDto>> {
    const obs = projectSubtaskCommentsControllerFindOne(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a comment by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSubtaskCommentsControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSubtaskCommentsControllerFindOne(params: ProjectSubtaskCommentsControllerFindOne$Params, context?: HttpContext): Observable<CoreProjectSubtaskCommentResponseDto> {
    const resp = this.projectSubtaskCommentsControllerFindOne$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreProjectSubtaskCommentResponseDto>): CoreProjectSubtaskCommentResponseDto => r.body)
    );
  }

  /** Path part for operation `projectSubtaskCommentsControllerDelete()` */
  static readonly ProjectSubtaskCommentsControllerDeletePath = '/o2-core/project-subtask-comments/{tenant}/{id}';

  /**
   * Delete a comment by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSubtaskCommentsControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSubtaskCommentsControllerDelete$Response(params: ProjectSubtaskCommentsControllerDelete$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectSubtaskCommentResponseDto>> {
    const obs = projectSubtaskCommentsControllerDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a comment by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSubtaskCommentsControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSubtaskCommentsControllerDelete(params: ProjectSubtaskCommentsControllerDelete$Params, context?: HttpContext): Observable<CoreProjectSubtaskCommentResponseDto> {
    const resp = this.projectSubtaskCommentsControllerDelete$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreProjectSubtaskCommentResponseDto>): CoreProjectSubtaskCommentResponseDto => r.body)
    );
  }

  /** Path part for operation `projectSubtaskCommentsControllerUpdate()` */
  static readonly ProjectSubtaskCommentsControllerUpdatePath = '/o2-core/project-subtask-comments/{tenant}/{id}';

  /**
   * Update a comment by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSubtaskCommentsControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectSubtaskCommentsControllerUpdate$Response(params: ProjectSubtaskCommentsControllerUpdate$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectSubtaskCommentResponseDto>> {
    const obs = projectSubtaskCommentsControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a comment by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSubtaskCommentsControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectSubtaskCommentsControllerUpdate(params: ProjectSubtaskCommentsControllerUpdate$Params, context?: HttpContext): Observable<CoreProjectSubtaskCommentResponseDto> {
    const resp = this.projectSubtaskCommentsControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreProjectSubtaskCommentResponseDto>): CoreProjectSubtaskCommentResponseDto => r.body)
    );
  }

}
